import { Player } from '@lottiefiles/react-lottie-player';
import './Loading.scss';

interface LoadingProps {
  status?: string;
}

const Loading: React.FC<LoadingProps> = ({ status }) => {
  return (
    <div className="loading">
      <Player
          autoplay
          loop
          src="https://lottie.host/e9475781-051c-4ff6-8dff-2a3fb28985c7/V9lFnchjrp.json"
          style={{ height: '150px', width: '150px' }}
        >
        </Player>
      {status && <p className="status">{status}</p>}
    </div>
  );
};

export default Loading;